import { cva, type VariantProps } from 'class-variance-authority';

const dividerStyles = cva('', {
	variants: {
		vertical: {
			true: 'border-l',
			false: 'grow border-b',
		},
		color: {
			grayBc3: 'defined-bc3',
			gray45: 'border-gray-45',
			gray40: 'border-gray-40',
			'hero/10': 'defined-bd-13',
		},
	},
	defaultVariants: {
		vertical: false,
		color: 'gray45',
	},
});

export type DividerProps = VariantProps<typeof dividerStyles>;

export function Divider({ vertical, color }: DividerProps) {
	return <div className={dividerStyles({ vertical, color })} />;
}
